/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslate } from "../../translate";
import { Formik, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Button from "@ingka/button";
import CustomInlineToast from "../CustomInlineToast";
import ValidationErrorMessage from "../ValidationErrorMessage";
import * as Yup from "yup";
import Constants from "../../Constants";
import { formatWithPlaceholders } from "../../util/utils";
import { PromptModalContainer } from "@afg-ikea/ikea-kiosk-related-components/dist/exports";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/forms/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";
import OTPPromptContainer from "../OtpLoginPrompt/OTPPrompt";
import "./CheckGiftCardBalanceModalBody.scss";
import {
  fetchBalanceByWallet,
  resetBalanceByWallet,
  fetchBalanceByGiftCard,
  resetBalanceByGiftCard,
} from "../../redux/giftBalance/giftBalanceActions";

import {
  sendOtp,
  resetLoginState,
  verifyOtp,
} from "../../redux/login/loginActions";

const CheckGiftCardBalanceModalBody = () => {
  const dispatch = useDispatch();
  const i18n = useTranslate();
  const { t, isRtl } = i18n;

  const balanceByWallet = useSelector(
    ({ giftBalance }) => giftBalance?.balanceByWallet?.balance
  );
  const balanceByWalletFetchingStatus = useSelector(
    ({ giftBalance }) => giftBalance?.balanceByWallet?.fetchingStatus?.state
  );

  const sendOtpSuccess = useSelector(
    ({ login }) => login?.sendOtp?.sendOtpSuccess
  );
  const verifyOtpSuccess = useSelector(
    ({ login }) => login?.verifyOtp?.verifyOtpSuccess
  );
  const sendOtpMobileNumber = useSelector(({ login }) => login?.mobileNumber);
  const verifyOtpErrorMessage = useSelector(
    ({ login }) => login?.verifyOtp?.error
  );
  const sendOtpErrorMessage = useSelector(
    ({ login }) => login?.sendOtp?.error?.message
  );

  const balanceByGiftCard = useSelector(
    ({ giftBalance }) => giftBalance?.balanceByGiftCard?.balance
  );
  const balanceByGiftCardFetchingStatus = useSelector(
    ({ giftBalance }) => giftBalance?.balanceByGiftCard?.fetchingStatus?.state
  );
  const balanceByGiftCardErrorMsg = useSelector(
    ({ giftBalance }) => giftBalance?.balanceByGiftCard?.error?.message
  );

  const initialPromptModalState = { visible: false, message: "" };
  const [promptModalState, setPromptModalState] = useState(
    initialPromptModalState
  );

  const resetWalletRelatedData = () => {
    dispatch(resetBalanceByWallet());
    dispatch(resetLoginState());
  };

  const resetCardRelatedData = () => {
    dispatch(resetBalanceByGiftCard());
  };

  useEffect(() => {
    return () => {
      resetWalletRelatedData();
      resetCardRelatedData();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (balanceByWallet !== undefined) {
      const msg = formatWithPlaceholders(
        t(
          "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.showBalanceMessage.title"
        ),
        `${balanceByWallet} ${t("currency")}`
      );
      setBalanceByWalletToastState({
        visible: true,
        title: msg,
        variant: "positive",
      });
    } else {
      setBalanceByWalletToastState({
        visible: false,
        title: undefined,
        variant: "positive",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceByWallet]);

  useEffect(() => {
    if (balanceByGiftCard !== undefined) {
      const msg = formatWithPlaceholders(
        t(
          "checkGiftWalletBalanceModalBody.balanceByGifCardSection.showBalanceMessage.title"
        ),
        `${balanceByGiftCard?.amount} ${t("currency")}`
      );
      let body = null;
      if (balanceByGiftCard?.cardExpiry) {
        body =
          t(
            "checkGiftWalletBalanceModalBody.balanceByGifCardSection.cardExpiry.title"
          ) +
          " " +
          new Date(balanceByGiftCard?.cardExpiry).toLocaleString();
      }
      setBalanceByGiftCardToastState({
        visible: true,
        title: msg,
        body: body,
        variant: "positive",
      });
    } else {
      setBalanceByGiftCardToastState({
        visible: false,
        title: undefined,
        variant: "positive",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceByGiftCard]);

  useEffect(() => {
    if (balanceByGiftCardErrorMsg) {
      setPromptModalState({
        visible: true,
        message: t(
          `checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.${balanceByGiftCardErrorMsg}`
        ),
      });
    }
  }, [balanceByGiftCardErrorMsg]);

  useEffect(() => {
    if (sendOtpErrorMessage) {
      setPromptModalState({
        visible: true,
        message:
          sendOtpErrorMessage === "sendOtpFailed"
            ? t(`walletLogin.OTPPrompt.sendOtpFailed.text`)
            : t("home.somethingWentWrong.title"),
      });
    }
  }, [sendOtpErrorMessage]);

  useEffect(() => {
    if (balanceByGiftCardErrorMsg) {
      setPromptModalState({
        visible: true,
        message: t(
          `checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.${balanceByGiftCardErrorMsg}`
        ),
      });
    }
  }, [balanceByGiftCardErrorMsg]);

  const [walletResetForm, setWalletResetForm] = useState();
  const [balanceByWalletToastState, setBalanceByWalletToastState] = useState({
    visible: false,
    title: undefined,
    variant: "positive",
  });

  const [balanceByGiftCardToastState, setBalanceByGiftCardToastState] =
    useState({
      visible: false,
      title: undefined,
      variant: "positive",
    });

  const giftCardNumberRegex = new RegExp(`^[0-9]{16}$|^[a-z0-9]{26}$`);
  const mobileNoLength = Constants[localStorage.countryCode].mobileNoLength;
  const mobileNoRegExp = `^\\d{${mobileNoLength}}$`;
  const phoneRegExp = new RegExp(mobileNoRegExp);

  const balanceByGiftCardsInitialValue = {
    giftCardNumber: "",
  };

  const balanceByGiftCardsValidationSchema = Yup.object({
    giftCardNumber: Yup.string()
      .required(
        t(
          "checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.textField.required.text"
        )
      )
      .matches(
        giftCardNumberRegex,
        t(
          "checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.textField.valid.text"
        )
      ),
  });

  const balanceByGiftWalletInitialValue = {
    giftWalletNumber: "",
  };

  const balanceByGiftWalletValidationSchema = Yup.object({
    giftWalletNumber: Yup.string()
      .required(
        t(
          "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.required.text"
        )
      )
      .matches(
        phoneRegExp,
        t(
          "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.valid.text"
        )
      ),
  });

  const extract16DigitCardNumber = ({ cardNo }) => {
    let pCard = "";
    for (var i = 0; i < cardNo.length; i++) {
      if (i !== 0 && i % 3 !== 0 && i !== cardNo.length - 1)
        pCard = `${pCard}${cardNo[i]}`;
    }
    return pCard;
  };

  const getWholeMobileNumber = ({ mobileNumber }) => {
    return `${t(
      "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.prefix"
    )}${mobileNumber}`;
  };

  const handleCheckBalanceByGiftCardBtnClick = ({ giftCardNumber }) => {
    dispatch(resetBalanceByGiftCard());
    let wholeNumber = giftCardNumber;
    if (giftCardNumber.length === 26) {
      wholeNumber = extract16DigitCardNumber({ cardNo: giftCardNumber });
    }
    dispatch(fetchBalanceByGiftCard({ cardNumber: wholeNumber }));
  };

  const handleSendOTPCheckBalanceByGiftWalletBtnClick = ({ mobileNumber }) => {
    const wholeNumber = getWholeMobileNumber({ mobileNumber });
    resetWalletRelatedData();
    dispatch(sendOtp({ mobileNumber: wholeNumber }));
  };

  const handleReSendOTPCheckBalanceByGiftWalletBtnClick = () => {
    if (sendOtpMobileNumber) {
      resetWalletRelatedData();
      dispatch(sendOtp({ mobileNumber: sendOtpMobileNumber }));
    }
  };

  const handleVerifyOTPCheckBalanceByGiftWalletBtnClick = ({ otp }) => {
    if (sendOtpMobileNumber) {
      dispatch(
        verifyOtp({
          otp,
          mobileNumber: sendOtpMobileNumber,
          callbackFn: () =>
            dispatch(
              fetchBalanceByWallet({ mobileNumber: sendOtpMobileNumber })
            ),
        })
      );
    }
  };

  const handleFormKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div
      className="check-gift-card-balance-modal-body"
      dir={isRtl() ? "rtl" : "ltr"}
    >
      <div className="header">
        <div className="header-title">
          {t("checkGiftCardBalanceModalBody.header.title")}
        </div>
        <div className="header-desc">
          {t("checkGiftCardBalanceModalBody.header.desc")}
        </div>
      </div>
      <hr />
      <div className="balance-by-gift-card-section">
        <Formik
          initialValues={balanceByGiftCardsInitialValue}
          validationSchema={balanceByGiftCardsValidationSchema}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            resetForm,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="gift-card-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input mobile-no-field">
                    <label
                      htmlFor="giftCardNumber"
                      title={t(
                        "checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.textField.label"
                      )}
                    >
                      {t(
                        "checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.textField.label"
                      )}
                    </label>
                    <div className="input-field__wrapper">
                      <input
                        type="text"
                        aria-describedby="giftCardNumber"
                        aria-required="false"
                        id="giftCardNumber"
                        name="giftCardNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.giftCardNumber}
                        placeholder={t(
                          "checkGiftCardBalanceModalBody.balanceByGiftCardSection.giftCard.textField.placeholder"
                        )}
                        maxLength={process.env.REACT_APP_GIFT_CARD_NUMBER_SIZE}
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="validation-error-msg-space">
                    <ErrorMessage
                      name="giftCardNumber"
                      component={ValidationErrorMessage}
                    />
                  </div>
                </div>
              </div>
              <div className="check-balance-btn-container">
                <Button
                  className="check-balance-btn"
                  type="emphasised"
                  text={t(
                    "checkGiftCardBalanceModalBody.balanceByGiftCardSection.checkBalance.btn.text"
                  )}
                  onClick={() => {
                    handleCheckBalanceByGiftCardBtnClick({
                      giftCardNumber: values.giftCardNumber,
                    });
                  }}
                  disabled={
                    !(dirty && isValid) ||
                    balanceByGiftCardFetchingStatus === "inProgress"
                  }
                />
              </div>
              {balanceByGiftCardToastState.visible && (
                <div className="check-balance-toast-container">
                  <CustomInlineToast
                    title={balanceByGiftCardToastState.title}
                    variant={balanceByGiftCardToastState.variant}
                    visible={balanceByGiftCardToastState.visible}
                    body={balanceByGiftCardToastState.body}
                    onClose={() => {
                      setBalanceByGiftCardToastState((prevState) => ({
                        ...prevState,
                        visible: false,
                      }));
                      resetForm();
                    }}
                  />
                </div>
              )}
            </form>
          )}
        </Formik>
        <hr />
      </div>
      <div className="balance-by-gift-wallet-section">
        <Formik
          initialValues={balanceByGiftWalletInitialValue}
          validationSchema={balanceByGiftWalletValidationSchema}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            resetForm,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="gift-wallet-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input mobile-no-field">
                    <label
                      htmlFor="giftWalletNumber"
                      title={t(
                        "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.label"
                      )}
                    >
                      {t(
                        "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.label"
                      )}
                    </label>
                    <div className="input-field__wrapper">
                      <div className="phone-code">
                        {t(
                          "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.prefix"
                        )}
                      </div>
                      <input
                        type="text"
                        aria-describedby="giftWalletNumber"
                        aria-required="false"
                        id="giftWalletNumber"
                        name="giftWalletNumber"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.giftWalletNumber}
                        placeholder={t(
                          "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.giftWallet.textField.placeholder"
                        )}
                        maxLength={mobileNoLength}
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="validation-error-msg-space">
                    <ErrorMessage
                      name="giftWalletNumber"
                      component={ValidationErrorMessage}
                    />
                  </div>
                </div>
              </div>
              {!sendOtpSuccess && (
                <div className="check-balance-btn-container">
                  <Button
                    className="check-balance-btn"
                    type="emphasised"
                    text={t(
                      "checkGiftWalletBalanceModalBody.balanceByGiftWalletSection.checkBalance.btn.text"
                    )}
                    onClick={() => {
                      handleSendOTPCheckBalanceByGiftWalletBtnClick({
                        mobileNumber: values.giftWalletNumber,
                      });
                      setWalletResetForm(() => resetForm);
                    }}
                    disabled={
                      !(dirty && isValid) ||
                      balanceByWalletFetchingStatus === "inProgress"
                    }
                  />
                </div>
              )}
            </form>
          )}
        </Formik>
        {sendOtpSuccess && !verifyOtpSuccess && (
          <OTPPromptContainer
            mobileNumber={sendOtpMobileNumber}
            onVerifyOtpClick={handleVerifyOTPCheckBalanceByGiftWalletBtnClick}
            onResendOtpClick={handleReSendOTPCheckBalanceByGiftWalletBtnClick}
            errorMessage={
              verifyOtpErrorMessage
                ? verifyOtpErrorMessage === "invalidOtp"
                  ? t("walletLogin.OTPPrompt.invalidOtp.text")
                  : t("home.somethingWentWrong.title")
                : ""
            }
          />
        )}
      </div>
      {balanceByWalletToastState.visible && (
        <div className="check-balance-toast-container">
          <CustomInlineToast
            title={balanceByWalletToastState.title}
            variant={balanceByWalletToastState.variant}
            visible={balanceByWalletToastState.visible}
            onClose={() => {
              setBalanceByWalletToastState((prevState) => ({
                ...prevState,
                visible: false,
              }));
              resetWalletRelatedData();
              if (walletResetForm) {
                walletResetForm();
              }
            }}
          />
        </div>
      )}
      {promptModalState.visible && (
        <div className="prompt_popup_extended">
          <PromptModalContainer
            visible={promptModalState.visible}
            onOkay={() => setPromptModalState(initialPromptModalState)}
          >
            <div> {promptModalState.message}</div>
            <div>
              <Button
                className="prompt_popup_extended-close-btn"
                type="emphasised"
                text={t("home.close.title")}
                onClick={() => setPromptModalState(initialPromptModalState)}
              />
            </div>
          </PromptModalContainer>
        </div>
      )}
    </div>
  );
};

export default CheckGiftCardBalanceModalBody;
